<template>
  <el-autocomplete
    class="select-input-auto-main"
    v-model="data.skill.description"
    :debounce="10"
    :hide-loading="true"
    label="skill"
    value-key="name"
    :fetch-suggestions="remoteMethod"
    :placeholder="placeholder"
    @select="select"
    @focus="focus()"
    :select-when-unmatched="true"
    type="textarea"
    :autosize="{ minRows: 1, maxRows: 500 }"
    resize="none">

    <template slot-scope="{ item }">
      <p v-html="item.highlight"></p>
    </template>

  </el-autocomplete>
</template>
<script>
	import api from '@/api'
	import { mapState, mapMutations } from 'vuex'

	export default {
		props: {
			data: {
        type: Object,
        default: {}
      },
      placeholder: {
        type: String,
        default: ''
      },
      separator: {
        type: String,
        default: ''
      }
		},
		data () {
			return {
        run: null,
        cacheValue: null, // 缓存输入的值
				options: [],
				value: {
					name: ''
				},
				list: [],
				loading: false,
			}
    },
		computed: {
			...mapState('editor', [ 'currentInfo' ])
    },
    mounted () {
      console.log('description', this.currentInfo.data.skill.description)
      let lastValue = this.currentInfo.data.skill.description.substr(this.currentInfo.data.skill.description.length - 1, 1)
      if (this.currentInfo.data.skill.description && (lastValue !== this.separator)) {
        this.currentInfo.data.skill.description += this.separator
      }
    },
		methods: {
			...mapMutations('editor', [ 'setCurrentInfo' ]),
			async remoteMethod (val, cb) {
        if (!val) return cb([])
        this.cacheValue = val
        let index = val.lastIndexOf(this.separator)
        let query = val.slice(index + 1)
        if (!query) return cb([])
				let params = {
          keyword: query
        };
        try {
          let res = await api.cvsEditor.skillAutoCompletions(params);
          if (res.code === 1000) {
            cb && cb((res.data || []));
          }
        } catch (e) {
          console.log('skillAutoCompletions error:', e)
        }
			},
			select (data) {
        if (!data.name) return
        let index = this.cacheValue.lastIndexOf(this.separator)
        let str = this.cacheValue.slice(0, index + 1) + data.name + this.separator
        this.currentInfo.data.skill.description = str
        this.cacheValue = str
      },
      focus () {
        this.$emit('customFocus')
      }
		}
	}
</script>
<style lang="scss" scoped>

  .select-input-auto-main {
    width: 100%;

    ::v-deep .el-autocomplete-suggestion {
      position: absolute;
      z-index: 10;
    }
  }

  ::v-deep .el-input__inner {
    border-color: #D8D8D8;
  }

  ::v-deep .es-highlighter {
    color: #FF6644;
  }

  ::v-deep .el-textarea__inner {
    min-height: 40px !important;
    line-height: 2 !important;
  }

</style>
